import * as z from 'zod';

export const liveAnalysisSchema = z.object({
    setupParameters: z.array(z.number()).min(1, 'Select at least one setup parameter'),
    eventParameters: z.array(z.number()),
    regDelay: z.number('Expected Number').int().min(0, 'Min 0').max(30, 'Max 30'),
    autoRestart: z.boolean(),
    iterations: z.number('Expected Number').optional().nullish(),
});

export type LiveAnalysisFormValues = z.infer<typeof liveAnalysisSchema>;
